import { createContext, useContext, useEffect, useState } from "react";
import io from "socket.io-client";
import { socketBaseUrl } from "../utils/constance";

// Socket Options
const socketOptions = {
  autoConnect: false, // Prevent auto connection, we will handle it manually
  reconnection: true,
  reconnectionDelay: 500,
  reconnectionDelayMax: 1000,
  reconnectionAttempts: Infinity,
  transports: ["websocket", "polling"],
  query: {
    api_token_temp: "android",
  },
};

// Create Context
const SocketContext = createContext(null);

// Provider Component
export function SocketProvider({ children }) {
  const [socket, setSocket] = useState(null);

  useEffect(() => {
    // Create socket instance
    const _socket = io(socketBaseUrl, socketOptions);

    // Handle connection and disconnection
    // _socket.on("connect", () => {
    //   console.log("Socket connected:", _socket.id);
    // });

    // _socket.on("disconnect", () => {
    //   console.log("Socket disconnected");
    // });

    // _socket.on("connect_error", (err) => {
    //   console.error("Socket connection error:", err);
    // });

    // Save socket instance
    setSocket(_socket);

    // Cleanup on unmount
    return () => {
      _socket.disconnect();
      console.log("Socket instance cleaned up");
    };
  }, []);

  return (
    <SocketContext.Provider value={{ socket }}>
      {children}
    </SocketContext.Provider>
  );
}

// Custom Hook
export function useSocketContext() {
  return useContext(SocketContext);
}
